import * as React from 'react'
// import * as ReactDom from 'react-dom'
import Socket from '../../../Socket/socket-init'
import * as Assets from '../../../assets/Assets'
import * as Body from '../../../Views/Main/Index/Body'
import { Redirect, Link } from 'react-router-dom'
import { Cookies, withCookies } from 'react-cookie'
import Loader from './Loader'

interface IProps {
  location: any
}

interface IState {
  username: string
  password: string
  newPassword: string
  newPasswordConfirmation: string
  mobileMenu: boolean
  checkbox: boolean
  forgotPassword: boolean
  userInput: string
}

class Login extends React.Component<IProps, IState> {

  public cookies

  constructor(props) {
    super(props)

    window.scroll(0, 0)

    const url = this.props.location.search
    const hash = this.getParameterByName('hash', url)
    const forgotPassword = this.getParameterByName('forgotpassword', url)

    Socket.Send('user-confirmation', { hash })
    Socket.Send('change-password', {hash: forgotPassword})

    this.cookies = new Cookies()

    const savedUsername = this.cookies.get('savedUsername')
    const savedPassword = this.cookies.get('savedPassword')

    this.state = {
      username: (savedUsername) ? savedUsername : '',
      password: (savedPassword) ? savedPassword : '',
      newPassword: '',
      newPasswordConfirmation: '',
      mobileMenu: false,
      checkbox: false,
      forgotPassword: false,
      userInput: ''
    }

    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleSubmitForgot = this.handleSubmitForgot.bind(this)
    this.handleSubmitNewPassword = this.handleSubmitNewPassword.bind(this)
  }

  handleInput(value: string, state: string) {
    this.state[state] = value
    this.setState(this.state)
  }

  handleSubmit(event) {
    event.preventDefault()
    if (this.state.username === '') {
      alert('Write your email.')
    } else if (this.state.password === '') {
      alert('Write your password.')
    } else {
      Socket.Send('login', {
        username: this.state.username.toLowerCase(),
        password: this.state.password
      })
    }
  }

  handleSubmitForgot(event) {
    event.preventDefault()
    if (this.state.userInput === '') {
      alert ('Write your email.')
    } else {
      Socket.Send('forgot-password', {userInput: this.state.userInput})
    }
  }

  handleSubmitNewPassword(event) {
    event.preventDefault()
    const userId = Socket.Get<any>('change-password').changePassword
    if (this.state.newPassword === '') {
      alert ('Write your password.')
    } else {
      Socket.Send('change-password', {userId, password: this.state.newPassword})
      Socket.Set('forgot-password', {})
      Socket.Set('change-password', {})
      return (<Redirect to="/login"/>)
    }
  }

  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
    const results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  render() {
    const login = Socket.Get<any>('login')
    if (login.login && login.login.id) {
      this.cookies.set('playerId', login.login.id/*, {secure: true}*/)
      this.cookies.set('username', login.login.username/*, {secure: true}*/)
      this.cookies.set('nationality', login.login.nationality/*, {secure: true}*/)
      this.cookies.set('competitionTab', 1/*, {secure: true}*/)
      const currentDate = new Date()
      const year = currentDate.getFullYear()
      const month = currentDate.getMonth()
      const day = currentDate.getDate()
      const date = new Date(year, month + 1, day)
      if (this.state.checkbox) {
        this.cookies.set('savedUsername', this.state.username, { expires: date })
        this.cookies.set('savedPassword', this.state.password, { expires: date })
      }
      return <Redirect to="/lounge" />
    }
    const userConfirmation = Socket.Get<any>('user-confirmation')
    const changePassword = Socket.Get<any>('change-password')
    if (userConfirmation.loading !== 'loaded' || changePassword.loading !== 'loaded') {
      return <Loader/>
    } else {
      const pathname = this.props.location.pathname
      const hash = '/login' + this.props.location.search
      return (
        <section className="wrapper">
          <div className="navigation-main-wrapper">
            <div className="navigation-main navbar navbar-default" style={{ marginBottom: '0' }}>
              <div className="container">
                <div className="row">
                  <Link className="navbar-brand" to="/">
                    <img src="logo-main2.png" alt="" className="logo logo-acc" />
                  </Link>
                  <button
                    onClick={() => this.setState({ mobileMenu: !this.state.mobileMenu })}
                    type="button"
                    className={(this.state.mobileMenu) ? 'navbar-toggle navbar-mid-toggle' : 'navbar-toggle navbar-mid-toggle collapsed'}
                    data-toggle="collapse"
                    data-target="#navbar-collapse-mid"
                    aria-expanded={(this.state.mobileMenu) ? 'true' : 'false'}
                  >
                    <span className="sr-only">Toggle navigation</span>
                    <span className="icon-bar" />
                    <span className="icon-bar" />
                    <span className="icon-bar" />
                  </button>
                  <div className="clearfix" />
                  <nav
                    className={(this.state.mobileMenu) ? 'collapse navbar-collapse navbar-mid-bar collapse in' : 'collapse navbar-collapse navbar-mid-bar'}
                    id="navbar-collapse-mid"
                    aria-expanded={(this.state.mobileMenu) ? 'true' : 'false'}
                    style={(this.state.mobileMenu) ? { height: '220px' } : { height: '1px' }}
                  >
                    {Body.getMenu('pull-left', Assets.menuLeft)}
                    {(this.state.mobileMenu) ? Body.getMenu('pull-left', Assets.menuRight) : Body.getMenu('pull-right', Assets.menuRight)}
                  </nav>
                </div>
              </div>
            </div>
          </div>
          <main className="main">
            <div className="container">
              <div className="panel panel-default two-column equal-height-wrapper">
                <div className="panel-left equal-height-col" style={{ padding: '50px 50px 0 50px' }}>
                  {(changePassword.changePassword && !changePassword.changePassword.error && !changePassword.changePassword.id) ?
                  <div className="form">
                    <div className="h3">
                      Password change
                    </div>
                    <div className="clearfix" />
                    <form onSubmit={this.handleSubmitNewPassword}>
                      <div
                        className="form-group"
                      >
                        <span>New password</span>
                        <input type="password" className="form-control" placeholder="" value={this.state.newPassword} onChange={(event) => this.handleInput(event.target.value, 'newPassword')} />
                      </div>
                      <div
                        className={(this.state.newPassword !== this.state.newPasswordConfirmation) 
                          ? 'form-group has-error'
                          : 'form-group'}
                        style={{ marginBottom: '30px' }}
                      >
                        <label>Confirm new password</label>
                        <input type="password" className="form-control" placeholder="" value={this.state.newPasswordConfirmation} onChange={(event) => this.handleInput(event.target.value, 'newPasswordConfirmation')} />
                        <span className="error-block">
                          <span>Passwords do not match</span>
                        </span>
                      </div>
                      <div className="form-group">
                        <button className="btn btn-lg btn-block btn-primary no-shadow">CHANGE PASSWORD</button>
                      </div>
                    </form>
                  </div>
                  :
                  <div className="form">
                    <div className="h3">
                      Login
                        </div>
                    <div className="clearfix" />
                    <form onSubmit={this.handleSubmit}>
                      <div
                        className={(login.login && login.login.error === 'User with this username or email does not exist.')
                          ? 'form-group has-error'
                          : 'form-group'}
                      >
                        <span>Email</span>
                        <input type="text" className="form-control" placeholder="" value={this.state.username.toLowerCase()} onChange={(event) => this.handleInput(event.target.value, 'username')} />
                        <span className="error-block">
                          <span>Incorrect email</span>
                        </span>
                      </div>
                      <div
                        className={(login.login && login.login.error === 'Password is incorrect.')
                          ? 'form-group has-error'
                          : 'form-group'}
                      >
                        <label>Password</label>
                        <input type="password" className="form-control" placeholder="" value={this.state.password} onChange={(event) => this.handleInput(event.target.value, 'password')} />
                        <span className="error-block">
                          <span>Incorrect password</span>
                        </span>
                      </div>
                      <div className="form-group display-block">
                        <div className="pull-left">
                          <span className="checkbox-wrapper">
                            <input type="checkbox" name="remember_me" checked={this.state.checkbox} onClick={() => this.setState({ checkbox: !this.state.checkbox })} />
                            <span className="checkbox-span" />Remember me
                          </span>
                        </div>
                        <div className="pull-right float-left">
                          <a className="btn-link forgot-link" onClick={() => this.setState({ forgotPassword: true })}>Forgot Password?</a>
                        </div>
                      </div>
                      <div className="form-group">
                        <button className="btn btn-lg btn-block btn-primary no-shadow">LOGIN</button>
                      </div>
                    </form>
                  </div>
                  }
                </div>
                <div className="panel-right display-table equal-height-col" style={{ padding: '60px' }}>
                  <div className="h3">
                    New to<br /> The Accumulator Club? Still Need to Create an Account?
                      </div>
                  <p>Become a valued member of The Accumulator Club for free. It’s a masterpiece of social football gaming, so pull your socks up and get involved!</p>
                  <div className="table-row">
                    <div className="vertical-bot text-center">
                      <div className="h3 margin-zero">
                        <Link to="/signup" className="btn-link">SIGN UP HERE</Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {(this.state.forgotPassword) ? this.showPopupForgot() : null}
            {(login.login && login.login.error === 'Not confirmed yet.') ? this.showPopupConfirm() : null}
            {(pathname !== hash) ? this.showPopup() : null}
          </main>
        </section>
      )
    }
  }

  showPopupForgot(): JSX.Element {
    const forgotPassword = Socket.Get<any>('forgot-password')
    const screenPosition = document.documentElement.scrollTop + 150
    const top = screenPosition.toString() + 'px'
    return(
      <div className="popup">
        <div className="popup-inner popup-forgot" style={{ top }}>
          <div style={{ textAlign: 'right' }}>
            <img src="cancel-black.png" style={{ cursor: 'pointer' }} onClick={() => {Socket.Set('forgot-password', {}), this.setState({ forgotPassword: false, userInput: '' })}}/>
          </div>
          {(forgotPassword.forgotPassword && forgotPassword.forgotPassword.success) ?
          <h4>Please check your email. We have sent you instructions for setting new password.</h4>
          :
          <div>
            <h4>Please enter your email. We will send you instructions for setting a new one.</h4>
            <form onSubmit={this.handleSubmitForgot}>
              <div
                className={(forgotPassword.forgotPassword && forgotPassword.forgotPassword.error) ? 'form-group has-error' : 'form-group'}
              >
                <span>Email</span>
                <input type="text" className="form-control" placeholder="" value={this.state.userInput} onChange={(event) => this.handleInput(event.target.value, 'userInput')} />
                <span className="error-block">
                  <span>Please enter valid email</span>
                </span>
              </div>
              <div className="form-group">
                <button className="btn btn-lg btn-block btn-primary no-shadow">SEND</button>
              </div>
            </form>
          </div>
          }
        </div>
      </div>
    )
  }

  showPopup(): JSX.Element {
    const userConfirmation = Socket.Get<any>('user-confirmation')
    const screenPosition = document.documentElement.scrollTop + 150
    const top = screenPosition.toString() + 'px'
    if (!userConfirmation.userConfirmation.error) {
      return (
        <div className="popup">
          <div className="popup-inner popup-forgot" style={{ top }}>
            <div className="fist-bump"><img src="fist-bump.svg" /></div>
            <p className="congratulations-second">Verified!</p>
            <p className="congratulations-third">Thank you for confirming your email address is present and correct - You can now login and get involved!</p>
            <Link to="/login" className="btn btn-lg btn-block btn-primary no-shadow">LOGIN</Link>
          </div>
        </div>
      )
    } else {
      return <Redirect to="/login" />
    }
  }

  showPopupConfirm(): JSX.Element {
    const screenPosition = document.documentElement.scrollTop + 150
    const top = screenPosition.toString() + 'px'
    return (
      <div className="popup">
        <div className="popup-inner popup-forgot" style={{ top }}>
          <div style={{ textAlign: 'right', marginBottom: '10px' }}>
            <img onClick={() => Socket.Set('login', {})} style={{ cursor: 'pointer' }} src="cancel-black.png" />
          </div>
          <p className="congratulations-third">Not quite,</p>
          <p className="congratulations-third">We need you to verify your email address before we can get you in the game!</p>
          <p className="congratulations-third">We sent an email with a verification link to the address you indicated. Please check your inbox, and your spam folder in case it was filtered there."</p>
        </div>
      </div>
    )
  }

}

export default withCookies(Login)


// WEBPACK FOOTER //
// ./src/Views/Main/Index/Login.tsx